import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';

import {Box} from '@mui/material';

import {kanbanMatchCardPrimaryButtonSizeSx} from '../BoardViewStyles';

import {EmpionButton} from '../../../../../../../components/EmpionButton/EmpionButton';
import {buildMatchDetailsHrefFromMatchesBoard} from '../../../../../../../lib/matchDetailsNav';

type Props = {
  matchId: string;
};

export const AcceptedMatchActions = ({matchId}: Props) => {
  const navigate = useNavigate();
  const {search} = useLocation();
  const {t} = useTranslation('translation', {keyPrefix: 'matchesPage.kanbanCard.actions'});

  const matchDetailsTo = useMemo(() => buildMatchDetailsHrefFromMatchesBoard(matchId, search), [matchId, search]);

  const handleOpenProfile = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    navigate(matchDetailsTo);
  };

  return (
    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3}}>
      <EmpionButton
        data-tour='matches.card.action.toProfile'
        size='small'
        variant='primary'
        onClick={handleOpenProfile}
        sx={kanbanMatchCardPrimaryButtonSizeSx}
      >
        {t('toProfile')}
      </EmpionButton>
    </Box>
  );
};
